import React, { forwardRef } from 'react';
import clsx from 'clsx';

import type { GridItemProps } from './Grid.types';

export const GridItem = forwardRef<HTMLElement, GridItemProps>(
  (
    {
      as: Component = 'div',
      area,
      children,
      xs,
      sm,
      md,
      lg,
      xl,
      startXs,
      startSm,
      startMd,
      startLg,
      startXl,
      colSpan,
      rowSpan,
      className,
      style,
      testId,
      theme,
    },
    ref
  ) => {
    // This function is used to set the grid-column and grid-row styles
    const spanFn = (span?: number | 'auto'): string | undefined => {
      if (typeof span === 'number') {
        return `span ${span} / span ${span}`;
      } else if (span === 'auto') {
        return 'auto';
      }
    };

    const gridItemStyles = {
      ...(area
        ? { gridArea: area }
        : {
            ...(colSpan ? { gridColumn: spanFn(colSpan) } : {}),
            ...(rowSpan ? { gridRow: spanFn(rowSpan) } : {}),
          }),
      ...style,
    };

    return (
      <Component
        className={clsx(
          {
            [`hg-grid-col-${xs}`]: xs,
            [`hg-grid-col-sm-${sm}`]: sm,
            [`hg-grid-col-md-${md}`]: md,
            [`hg-grid-col-lg-${lg}`]: lg,
            [`hg-grid-col-xl-${xl}`]: xl,
            [`hg-grid-start-${startXs}`]: startXs,
            [`hg-grid-start-sm-${startSm}`]: startSm,
            [`hg-grid-start-md-${startMd}`]: startMd,
            [`hg-grid-start-lg-${startLg}`]: startLg,
            [`hg-grid-start-xl-${startXl}`]: startXl,
          },
          className
        )}
        style={gridItemStyles}
        ref={ref}
        data-testid={testId}
        data-theme={theme}
      >
        {children}
      </Component>
    );
  }
);

GridItem.displayName = 'GridItem';
